import React from "react";
import {
  Layout,
  Input,
  Button,
  Row,
  Col,
  Typography,
  Spin,
  message,
  Tooltip,
  Modal,
  Table,
} from "antd";
import Top from "../../components/common/Top";
import Footer from "../../components/common/Footer";

import { connect } from "react-redux";

import InfoDetail from "../../components/common/InfoDetail";
import { getFilesList } from "../../utils/api";

class Policy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: [],
      loading: false,
      detailInfo: {},
      pagination: {
        current: 1,
        pageSize: 10,
      },
    };
  }

  componentDidMount() {
    this.fetchData();
    if (this.props.location.query?.detail) {
      this.goDetail(this.props.location.query?.detail);
    }
  }

  onChange = (pagination, filters, sorter) => {
    this.setState(
      {
        pagination,
      },
      () => {
        this.fetchData();
      }
    );
  };

  fetchData = async () => {
    const { pagination } = this.state;
    this.setState({
      loading: true,
    });
    const params = {
      type: 1,
      pageIndex: pagination.current - 1 || 0,
      pageSize: pagination.pageSize || 10,
    };
    const res = await getFilesList(params);
    if (res.code === 0) {
      this.setState({
        dataSource: res.data,
        loading: false,
        pagination: {
          ...pagination,
          total: res.data.count,
        },
      });
    }
  };

  goDetail = (row) => {
    this.setState({
      detailInfo: {
        ...row,
        name: "政策文件",
      },
    });
  };

  goBack = () => {
    this.setState({
      detailInfo: {},
    });
  };

  render() {
    const { dataSource, loading, pagination, detailInfo } = this.state;
    const columns = [
      {
        title: "信息名称",
        dataIndex: "title",
        key: "title",
        ellipsis: true,
      },
      {
        title: "文号",
        dataIndex: "documentNo",
        key: "houseTypeName",
        ellipsis: true,
      },
      {
        title: "发布日期",
        dataIndex: "publicTime",
        key: "publicTime",
        width: 200,
      },
    ];
    return (
      <Layout style={{ minHeight: "100%", minWidth: "100%" }} id="policyPage">
        <Top />
        <Layout>
          <Row>
            <div className="col-lg-2"></div>
            <div className="col-lg-8 col-xs-12 projectContent">
              {detailInfo.id ? (
                <InfoDetail goBack={this.goBack} info={detailInfo} />
              ) : (
                <div>
                  <div
                    style={{
                      margin: "30px 0",
                      borderBottom: "1px solid #0263ac",
                    }}
                  >
                    <div
                      style={{
                        color: "#fff",
                        background: "#0263ac",
                        display: "inline-block",
                        padding: "10px 30px",
                        fontSize: 20,
                      }}
                    >
                      政策法规
                    </div>
                  </div>
                  <div>
                    <Table
                      rowKey="id"
                      columns={columns}
                      dataSource={dataSource?.pageContent}
                      pagination={pagination}
                      rowClassName="editable-row"
                      onChange={this.onChange}
                      loading={loading}
                      onRow={(record) => {
                        return {
                          onClick: (event) => {
                            this.goDetail(record);
                          }, // 点击行
                        };
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="col-lg-2"></div>
          </Row>
        </Layout>
        {/* <Footer /> */}
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userLoginInfo: state.userLoginInfo,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Policy);
